import type { Module } from 'vuex';
import { LanguageGroupItem } from '@/types/LanguageGroupItem';
import {RootState} from "@/store";

export interface LanguageGroupItemsState {
  languageGroupItems: LanguageGroupItem[];
}

const languageGroupItemsModule: Module<LanguageGroupItemsState, RootState> = {
  namespaced: true,

  state: (): LanguageGroupItemsState => ({
    languageGroupItems: [],
  }),

  getters: {
    getById: (state) => (idLanguageGroupItem: number): LanguageGroupItem | undefined => {
      return state.languageGroupItems.find(languageGroupItem => languageGroupItem.idLanguageGroupItem === idLanguageGroupItem);
    },
  },

  mutations: {
    setLanguageGroupItems(
      state,
      payload: { languageGroupItems: Record<number, any> }
    ) {
      state.languageGroupItems = Object
        .values(payload.languageGroupItems)
        .map(raw => LanguageGroupItem.fromRaw(raw));
    },

    setLanguageGroupItemCreate(
      state,
      payload: {
        idLanguageGroupItem: number;
        idLanguageGroup: number;
        code: string;
      }
    ) {
      const languageGroupItem = new LanguageGroupItem(
        payload.idLanguageGroupItem,
        payload.idLanguageGroup,
        payload.code,
        false,
      );
      state.languageGroupItems.push(languageGroupItem);
    },

    setLanguageGroupItemDelete(
      state,
      payload: { idLanguageGroupItem: number }
    ) {
      state.languageGroupItems = state.languageGroupItems.filter(
        languageGroupItem => languageGroupItem.idLanguageGroupItem !== payload.idLanguageGroupItem
      );
    },
  },

  actions: {
    wsSetLanguageGroupItems({ commit }, payload) {
      commit('setLanguageGroupItems', payload);
    },
    wsLanguageGroupItemCreate({ commit }, payload) {
      commit('setLanguageGroupItemCreate', payload);
    },
    wsLanguageGroupItemDelete({ commit }, payload) {
      commit('setLanguageGroupItemDelete', payload);
    },
  },
};

export default languageGroupItemsModule;
